import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, TextField, Typography, InputAdornment, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

const ManualArqAuxiliar = ({ open, handleClose }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const textContent = `
1 - Funcionamento do Componente de Conciliação de Arquivo Auxiliar e Descrição dos Campos
1.1 Objetivo:
O sistema é projetado para facilitar o processo de conciliação de arquivos auxiliares. Ele permite carregar tanto o arquivo do sistema quanto o arquivo auxiliar, processar esses arquivos e visualizar os resultados da conciliação.
Para efetuar a conciliação são extraídos os registros de ambos os arquivos e comparado os valores de crédito e/ou débito correspondentes.

1.2 Carregamento de Arquivos:
Arquivo do Sistema: Este campo permite ao usuário selecionar o arquivo contábil gerado pelo sistema da empresa. Ele pode escolher o sistema de origem do arquivo ou a opção Padrão se utilizar o layout padrão do sistema.

Arquivo Auxiliar: Aqui, o usuário pode selecionar o arquivo auxiliar fornecido por outra fonte. Também é possível especificar a origem do arquivo ou a opção Padrão se utilizar o layout padrão do sistema.

Padrão no Histórico:
Informar quais os padrões no histórico que o sistema deverá considerar para localizar os registros a serem conciliados. Por exemplo, se o registro a ser localizado é a nota fiscal e no histórico estiver como NFe 123, o padrão será NFe. Se existir mais de um padrão, por exemplo, NFe, NFE e NF, devem ser inseridos e separados por ";". Por exemplo: NFe;NFE;NF.


1.3 Processamento:
Após carregar os arquivos e selecionar as opções adequadas, o usuário pode clicar no botão "Processar" para iniciar o processamento dos arquivos. Durante esse processo, uma barra de progresso pode ser exibida para indicar o andamento da operação.

1.4 Resultados da Conciliação:
Após o processamento, os resultados da conciliação são apresentados em duas seções :

 O sistema exibe os campos Data, Créditos, Débitos, Conciliação Registro, Conciliação Valores,  Histórico, Lote, Razão Social e Registro.

 O campo Conciliação Registro indica se existem registros correspondentes em ambos os arquivos e o campo Conciliação Valores indica se os valores de crédito/débito desses registros são iguais.

Registro do Sistema: Mostra as transações registradas no sistema contábil da empresa, juntamente com informações adicionais, como data, créditos, débitos, histórico, lote, razão social, e registro, além do status de conciliação.

Registro do Arquivo Auxiliar: Exibe as transações registradas no arquivo auxiliar, incluindo data, créditos, débitos, histórico, lote, razão social, e registro, além do status de conciliação.

`;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Manual de conciliação de arquivo auxiliar
        <IconButton
          aria-label="close"
          onClick={handleClose}
          style={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          placeholder="Buscar..."
          onChange={handleSearch}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
        <Typography component="pre" variant="body1" style={{ whiteSpace: 'pre-wrap', marginTop: '16px', fontSize: '14px', lineHeight: '1.6' }}>
          {textContent.split('\n').map((line, index) => (
            <span
              key={index}
              style={{
                backgroundColor: line.toLowerCase().includes(searchTerm.toLowerCase()) && searchTerm ? 'yellow' : 'inherit',
              }}
            >
              {line}
              <br />
            </span>
          ))}
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default ManualArqAuxiliar;
